module.exports = __webpack_public_path__ + "static/media/18c-07_ST-2018-244x244cm-oleo-sobre-madera.cdd8ee29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-07_ST-2018-244x244cm-oleo-sobre-madera.jpg
// module id = 234
// module chunks = 0